import { render, staticRenderFns } from "./tabSpecialGoodsUICustom.vue?vue&type=template&id=46d74221&scoped=true&"
import script from "./tabSpecialGoodsUICustom.vue?vue&type=script&lang=js&"
export * from "./tabSpecialGoodsUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabSpecialGoodsUICustom.vue?vue&type=style&index=0&id=46d74221&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d74221",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46d74221')) {
      api.createRecord('46d74221', component.options)
    } else {
      api.reload('46d74221', component.options)
    }
    module.hot.accept("./tabSpecialGoodsUICustom.vue?vue&type=template&id=46d74221&scoped=true&", function () {
      api.rerender('46d74221', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabSpecialGoodsUICustom.vue"
export default component.exports